import React from 'react';
import PropTypes from 'prop-types';

import { useIsSmallScreen } from '../../../hooks/useIsSmallScreen';
import Button from '../../Button';
import { H2 } from '../../Typography';

import styles from './SinglePaymentCardExperiment.module.scss';

export const SinglePaymentCardExperiment = ({
  action,
  title,
  subtitle,
  price,
}) => {
  const isSmallScreen = useIsSmallScreen();

  const buttonText = 'CONTINUE';
  const priceText = 'BILLED ONCE';

  return !isSmallScreen ? (
    <div className={styles.singleLeaseContainer}>
      <div className={styles.textContainer}>
        <H2 className={styles.singleLeaseTitle}>{title}</H2>
        <H2 className={styles.singleLeaseSubtitle}>{subtitle}</H2>
      </div>
      <div className={styles.singleLeasePriceContainer}>
        <H2 className={styles.singleLeasePrice}>{price}</H2>
        <H2 className={styles.singleLeasePriceText}>{priceText}</H2>
        <Button
          className={styles.singleLeaseButton}
          onClick={action}
          variant="secondary"
          id="one-time-payment"
        >
          {buttonText}
        </Button>
      </div>
    </div>
  ) : (
    <div className={styles.singleLeaseContainerMobile}>
      <H2 className={styles.singleLeaseTitleMobile}>{title}</H2>
      <H2 className={styles.singleLeaseSubtitleMobile}>{subtitle}</H2>
      <div className={styles.singleLeasePriceContainerMobile}>
        <H2 className={styles.singleLeasePriceMobile}>{price}</H2>
        <H2 className={styles.singleLeasePriceTextMobile}>{priceText}</H2>
      </div>
      <Button
        className={styles.singleLeaseButtonMobile}
        onClick={action}
        variant="secondary"
        id="one-time-payment"
      >
        {buttonText}
      </Button>
    </div>
  );
};

SinglePaymentCardExperiment.propTypes = {
  action: PropTypes.func,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  price: PropTypes.string,
};
